export const roundOff = (number) => {
  const num = Number(number);
  if (String(number) !== '0') {
    return String(Number.parseFloat(num).toFixed(1));
  }
  // return String(number);
  return '-';
};

export const getTime = (fullDate) => {
  const date = new Date(fullDate);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  // Check whether AM or PM
  const newformat = hours >= 12 ? 'PM' : 'AM';
  // Find current hour in AM-PM Format
  hours = hours % 12;
  // To display "0" as "12"
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;

  const time = hours + ':' + minutes + ' ' + newformat;
  return time;
};

export const getMilliseconds = (timestamp) => {
  const currentTimestamp = new Date().getTime() / 1000;
  return timestamp - currentTimestamp;
};

export const getDate = (timestamp) => {
  return new Date(timestamp).toDateString().slice(-11);
};

export const getFullDate = (timestamp) => {
  const date = getDate(timestamp);
  const time = getTime(timestamp);
  const fullDate = `${date}, ${time}`;
  return fullDate;
};

export const getFormData = (component, value) => {
  let data = {};
  if (!component) return null;
  const { input } = component;
  if (input) {
    data[input.key] = value;
  } else {
    data[component.key] = value;
  }
  return data;
};

export const checkIfOptional = (component, value) => {
  if (component && typeof component.optional == 'undefined') {
    return true;
  } else if (component && !component.optional) {
    if (!value || !value.trim().length) {
      return false;
    }
  }
  return true;
};

export const copyToClipboard = async (value) => {
  if (document.hasFocus()) await navigator.clipboard.writeText(value);
};

export const getMonthString = (number) => {
  const monthNames = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  return monthNames[number];
};

export const getStickyTitle = (toast, selectedOption) => {
  if (!toast) return null;
  if (toast && toast.toast_object && selectedOption) {
    return toast.toast_object[selectedOption];
  } else {
    return toast.text;
  }
};

export const getSubmitBtnTitle = (button, selectedOption) => {
  if (!button) return null;
  if (button && button.submit_button_object && selectedOption) {
    return button.submit_button_object[selectedOption];
  } else {
    return button.text;
  }
};

export const checkRadioValidations = (radio) => {
  if (!radio.selectedValue) return false;
  return radio.source.some((item) => {
    if (String(item.value) === String(radio.selectedValue)) {
      if (item.radio && !item.radio.selectedValue) return false;
      if (item.input_box && !item.input_box.selectedInputValue) return false;
      if (item.dropdown && !item.selectedDropdownValue) return false;
      if (item.radio) {
        return checkRadioValidations(item.radio);
      }
      return true;
    }
    return false;
  });
};

export const getSelectedRadioOptions = (radio, data = {}) => {
  if (!radio) return null;
  let radioData, inputData, dropdownData;
  radioData = getFormData(radio, radio?.selectedValue);
  radio.source.map((item) => {
    if (item?.radio?.selectedValue) {
      getSelectedRadioOptions(item?.radio, data);
    }
    if (item?.input_box?.selectedInputValue) {
      inputData = getFormData(
        item.input_box,
        item.input_box.selectedInputValue,
      );
    }
    if (item?.dropdown && item?.selectedDropdownValue) {
      inputData = getFormData(item.dropdown, item.selectedDropdownValue);
    }
    return true;
  });
  Object.assign(data, radioData, inputData, dropdownData);
  return data;
};

export const getHrefUserId = (location) => {
  if (!location) return;
  const urlParams = new URLSearchParams(location.search);
  const key = urlParams.get('user-id');
  return key;
};

export const getHrefOrderId = (location) => {
  if (!location) return;
  const urlParams = new URLSearchParams(location.search);
  const key = urlParams.get('order') || urlParams.get('cp_o_id');
  return key;
};

export const getHrefCartId = (location) => {
  if (!location) return;
  const urlParams = new URLSearchParams(location.search);
  const key = urlParams.get('uc_cart_id');
  return key;
};

export const getMultiSelectData = (component, componentValue) => {
  let data = {};
  if (!component || !componentValue) return null;
  const { input, source } = component;

  let valueToSend = [];

  for (const [value, quantity] of Object.entries(componentValue)) {
    const currentItemFromSource = source.find((s) => s.value == value);

    let itemDetails = {
      value,
      quantity,
    };

    // List of tag slugs from list of tag objects
    if (currentItemFromSource.tags) {
      itemDetails.tags = currentItemFromSource.tags.map(
        ({ slug }) => slug
      );
    }

    valueToSend.push(itemDetails);
  }

  data[input.key] = valueToSend;
  return data;
};
